import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
import { slideInDownAnimation } from '../../app/app.animation';
// Common
import {
  AngularMaterialService,
  ErrorParseService,
  IPaymentFoundationTrustee,
  PermissionsService,
} from '../../commons';
// State
import { Store } from '@ngrx/store';
import * as fromPaymentFoundationTrustee from './state/payment-foundation-trustee.selectors';
import * as PaymentFoundationTrusteeAction from './state/payment-foundation-trustee.actions';
import * as lgeApp from '../../app/state/app.actions';
import { Observable, skipWhile, Subscription } from 'rxjs';

@Component({
  selector: 'payment-foundation-trustee-screen',
  templateUrl: 'payment-foundation-trustee.component.html',
  styleUrls: ['payment-foundation-trustee.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentFoundationTrusteeScreenComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() pending$: Observable<boolean>;
  pendingSubscription: Subscription;
  pending: boolean;
  @Input() error$: Observable<string | null>;
  errorSubscription: Subscription;
  error: string | null;
  @Input() stateData$: Observable<IPaymentFoundationTrustee[] | null>;
  stateDataSubscription: Subscription;
  @Input() processedData$: Observable<IPaymentFoundationTrustee[] | null>;
  processedDataSubscription: Subscription;
  foundationPaymentDetail: IPaymentFoundationTrustee[] | null;
  processedFoundationPaymentDetail: IPaymentFoundationTrustee[] | null;

  constructor(
    private store: Store<fromPaymentFoundationTrustee.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private permissionService: PermissionsService,
    private errorParse: ErrorParseService
  ) {
    this.selectState();
    this.createForms();
  }

  ngOnInit() {
    this.startSubscriptions();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.store.dispatch(
        new PaymentFoundationTrusteeAction.LoadPaymentFoundationTrusteeState()
      );
    });
  }
  // Select state
  private selectState(): void {
    this.pending$ = this.store.select(
      fromPaymentFoundationTrustee.getPaymentFoundationTrusteeScreenPending
    );
    this.stateData$ = this.store.select(
      fromPaymentFoundationTrustee.getPaymentFoundationTrusteeState
    );
    this.processedData$ = this.store.select(
      fromPaymentFoundationTrustee.getProcessedPaymentFoundationTrusteeState
    );
    this.error$ = this.store
      .select(
        fromPaymentFoundationTrustee.getPaymentFoundationTrusteeScreenError
      )
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
  }

  hasRole(role) {
    return this.permissionService.hasRoles(role);
  }
  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading...');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert('Loading Error', errorMessage);
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(
        new PaymentFoundationTrusteeAction.PaymentFoundationTrusteeScreenErrorReset()
      );
    });
  }

  // Create reactive forms
  private createForms(): void {}
  // Opens sidenav if on mobile
  public openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }
  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });
    this.stateDataSubscription = this.stateData$.subscribe((data) => {
      if (data !== null) {
        // this.store.dispatch(new PaymentFoundationTrusteeAction.LoadProcessedPaymentFoundationTrusteeState());
        let temp = JSON.parse(JSON.stringify(data));
        this.foundationPaymentDetail = temp;
      }
      this.ref.markForCheck();
    });
    this.processedDataSubscription = this.processedData$.subscribe((data) => {
      if (data != null) {
        let temp = JSON.parse(JSON.stringify(data));
        temp.map((value) => {
          if (value.statusAdmin === 'Negotiable') {
            value.statusAdmin = 'Check Issued';
          }
          return value;
        });
        this.processedFoundationPaymentDetail = temp;
      }
      this.ref.markForCheck();
    });
  }
  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.stateDataSubscription.unsubscribe();
    this.store.dispatch(
      new PaymentFoundationTrusteeAction.LoadPaymentFoundationTrusteeStateSuccess(
        null
      )
    );
    this.store.dispatch(
      new PaymentFoundationTrusteeAction.LoadProcessedPaymentFoundationTrusteeStateSuccess(
        null
      )
    );
  }

  ngOnDestroy() {
    this.endSubscriptions();
  }
}
